// Module
var code = "<section class=\"cr-card {{ ::$ctrl.customClass }}\" ng-click=\"$ctrl.onClick()\"> <header class=\"cr-body\">{{ ::$ctrl.label }}</header> <div ng-transclude=\"chartContainer\"></div> <section ng-transclude=\"statContainer\"></section> <div ng-transclude></div> </section> ";
// Exports
export default code;